import { takeLatest, put, call, select, take } from 'redux-saga/effects';

import { 
  getContextReportDateIfNeeded,
  getCampaignReportDateIfNeeded,
  getCampaignReportCsvFileIfNeeded,
  getMessageHistoryIfNeeded,
  getEmailClickMetricsIfNeeded,
  getClickedUrlsIfNeeded
} from './sagas';

import {
  GET_CONTEXT_REPORT_DATA,
  GET_CAMPAIGN_REPORT_DATA,
  GETTING_CAMPAIGN_REPORT_DATA_FAILED,
  GET_CAMPAIGN_REPORT_CSV_FILE,
  SWITCH_CAMPAIGN_REPORT_DATA,
  GET_MESSAGE_HISTORY,
  GET_EMAIL_CLICK_METRICS,
  GET_CLICKED_URLS
} from './actions';
import { actions as UserActions } from 'store/user';
import { actions as userMessaging } from 'store/userMessaging';
import { push } from 'connected-react-router';

/* Helper Sagas */

function* waitForUserReady() {
  const userReady = yield select(store => store.user.ready);
  if (!userReady) {
    yield take(UserActions.LOGIN_READY);
  }
}

/* APP FLOW - Campaigns */
function* ContextReportDataSaga() {
  yield takeLatest(GET_CONTEXT_REPORT_DATA, function*(action) {
    yield call(waitForUserReady);
    yield call(getContextReportDateIfNeeded, action);
  });
}

function* CampaignReportDataSaga() {
  yield takeLatest(GET_CAMPAIGN_REPORT_DATA, function*(action) {
    yield call(waitForUserReady);
    yield call(getCampaignReportDateIfNeeded, action);
  });
}

function* CampaignReportDataSagaFailed() {
  yield takeLatest([GETTING_CAMPAIGN_REPORT_DATA_FAILED], function*(action) {
    if (action?.payload?.suppressUserMessage) {
      return;
    }

    yield put(
      userMessaging.setMessageForFailedAction({
        type: action.type,
        error: action.payload
      })
    );
  });
}

function* CampaignReportCsvDataSaga() {
  yield takeLatest(GET_CAMPAIGN_REPORT_CSV_FILE, getCampaignReportCsvFileIfNeeded);
}

function* forceGetCampaignReport(action) {
  const { value, type, openFilter } = action.payload;
  if (value && type) {
    yield put(push(`/reports/campaigns/${action.payload.value}/${action.payload.type}/details${openFilter ? `?isFilterOpen=true`: ``}`));
  } else {
    yield put(push('/reports'));
  }
}

function* SwitchCampaignReportDataSaga() {
  yield takeLatest(SWITCH_CAMPAIGN_REPORT_DATA, forceGetCampaignReport);
}

function* GetMessageHistorySaga() {
  yield takeLatest(GET_MESSAGE_HISTORY, function*(action) {
    yield call(waitForUserReady);
    yield call(getMessageHistoryIfNeeded, action);
  });
}

function* GetEmailClickMetricsSaga() {
  yield takeLatest(GET_EMAIL_CLICK_METRICS, function*(action) {
    yield call(waitForUserReady);
    yield call(getEmailClickMetricsIfNeeded, action);
  });
}

function* GetClickedUrlsSaga() {
  yield takeLatest(GET_CLICKED_URLS, function*(action) {
    yield call(waitForUserReady);
    yield call(getClickedUrlsIfNeeded, action);
  });
}

export default [
  ContextReportDataSaga,
  CampaignReportDataSaga,
  CampaignReportDataSagaFailed,
  CampaignReportCsvDataSaga,
  SwitchCampaignReportDataSaga,
  GetMessageHistorySaga,
  GetEmailClickMetricsSaga,
  GetClickedUrlsSaga
];
